import { render, staticRenderFns } from "./FAQManagementWrite.vue?vue&type=template&id=6679e6e4&scoped=true"
import script from "./FAQManagementWrite.vue?vue&type=script&lang=js"
export * from "./FAQManagementWrite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6679e6e4",
  null
  
)

export default component.exports